import { MarketingHeroPill } from '@/components/marketing/v2/MarketingHeroPill';

type Props = {
  lastUpdated: string;
};

export default function LegalHeroV2({ lastUpdated }: Props) {
  return (
    <section className="bg-paper pb-10 pt-16 md:pb-14 md:pt-20">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <MarketingHeroPill>Documents officiels · Version 2026</MarketingHeroPill>

        <h1 className="mt-7 max-w-[14ch] font-marketing-display text-[clamp(48px,7vw,104px)] font-bold leading-[0.9] tracking-[-0.045em] text-charcoal-800">
          Les textes. <span className="text-charcoal-400">Sans jargon.</span>
        </h1>

        <p className="mt-6 max-w-2xl font-marketing-body text-lg leading-[1.55] text-charcoal-600 md:text-xl">
          Les documents juridiques qui encadrent Velko. Écrits pour être compris par un humain, pas
          pour te piéger en page 43. Juridiction camerounaise et OHADA.
        </p>

        <div className="mt-9 flex flex-wrap gap-6 border-t-2 border-charcoal-800 pt-6 font-marketing-mono text-[12px] uppercase tracking-[0.08em] text-charcoal-600">
          <span>
            Dernière mise à jour · <b className="font-bold text-charcoal-800">{lastUpdated}</b>
          </span>
          <span>
            Juridiction · <b className="font-bold text-charcoal-800">Cameroun · OHADA</b>
          </span>
          <span>
            Langue d'origine · <b className="font-bold text-charcoal-800">Français</b>
          </span>
        </div>
      </div>
    </section>
  );
}
